import { FormLayout, Heading, Input, LoadingProgress, Panel, Text } from "@/ui";
import panelStyles from "./GeneralsForm.module.scss";
import styles from "./GoogleForm.module.scss";

const GoogleForm = ({ toolbar, inputs, inputChange, loading }) => {
    return (
        <Panel
            className={panelStyles.root}
            header={
                <div className={panelStyles.headerBar}>
                    <div className={styles.headerText}>
                        <Heading level={4}>Google</Heading>
                        <Text tone="secondary" variant="body-md">
                            Google Information
                        </Text>
                    </div>
                    {toolbar ? (
                        <div className={panelStyles.headerActions}>
                            {toolbar}
                        </div>
                    ) : null}
                </div>
            }
            showHeaderDivider
        >
            {loading ? (
                <div className={panelStyles.loading}>
                    <LoadingProgress
                        indeterminate
                        indicator="circular"
                        size="sm"
                        title="Loading"
                    />
                </div>
            ) : (
                <FormLayout>
                    <FormLayout.Section title="Information">
                        {/* Col lg={4} */}
                        <FormLayout.Grid columns={3}>
                            <Input
                                fullWidth
                                label="GTM ID"
                                name="gtm_id"
                                onChange={inputChange}
                                value={inputs.gtm_id ?? ""}
                            />
                        </FormLayout.Grid>
                        {/* Col lg={7} ≈ twoThirds */}
                        <FormLayout.Grid columns={1} maxWidth="twoThirds">
                            <Input
                                fullWidth
                                label="Google Search Console verification token"
                                name="google_site_verification"
                                onChange={inputChange}
                                value={inputs.google_site_verification ?? ""}
                            />
                        </FormLayout.Grid>
                        <FormLayout.Grid columns={1} maxWidth="twoThirds">
                            <Input
                                fullWidth
                                label="Google Map Api URL"
                                name="google_map_api_url"
                                onChange={inputChange}
                                value={inputs.google_map_api_url ?? ""}
                            />
                        </FormLayout.Grid>
                    </FormLayout.Section>
                </FormLayout>
            )}
        </Panel>
    );
};

export default GoogleForm;
